import { map, mergeMap } from "rxjs/operators";
import { GeneralService } from "src/app/services/general.service";
import { Store } from "@ngrx/store";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import DateUtils from "src/app/utils/date";
import { environment } from "src/environments/environment";
import { bulkActionModel, TicketModel } from "./../../models/ticket/ticket.model";
import { Endpoints } from "./../../shared/config/endpoints";
import { OrgModel, UserModel } from "./../../store/storeModels/user.model";
import { AppState } from "src/app/store/app.state";
import { catchError } from "rxjs/operators";
import { Observable, of } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class TicketService {
  private api = this.endpoint.ticketUrl;
  private websiteUrl = environment.notchWebsite;
  private signupApi = this.endpoint.signUpEndpoint;
  private chatUrl = environment.chatServiceUrl;
  private tenantInfo = environment.notchTenantInfo;
  private newDate = new DateUtils();
  private user: UserModel;
  private org: OrgModel;
  private powerBy = `<footer style="margin-top: 50px">
  <b>Powered by <a href="${this.websiteUrl}">NotchCRM</a></b></footer>`;
  // private group: { id: any, name: string } = { id: '', name: '' };
  constructor(
    private endpoint: Endpoints,
    private http: HttpClient,
    private gs: GeneralService,
    store: Store<AppState>
  ) {
    store.select("userInfo").subscribe((info) => {
      this.org = info.organization;
      this.user = info.user;
    });
  }

  createTicket(payload) {
    const body = {
      ...payload,
      clientID: Number(payload.clientName.id),
      clientName: payload.clientName.name,
      sender: payload.clientName.email,
      lastResponse: this.newDate.getCurrentTs(),
      dueDate: this.newDate.getEndTimeStp(payload.dueDate),
      orgID: this.org.id,
      agentName: payload.agentName, // ? payload.agentName : `${this.user.firstName} ${this.user.lastName}`,
      agentID: payload.agentID, // ? payload.agentID : this.user.id,
      groupName: payload.groupName, // ? payload.groupName : this.user.groupName,
      groupID: payload.groupID, // ? payload.groupID : this.user.groupID,
      agentPix: payload.agentPix, // ? payload.agentPix : this.user.userImg,
    };
    return this.http.post(this.api + `/newTicket/${this.org.name}`, body);
  }
  getTicketByCode(code: string) {
    return this.http.get<any>(`${this.api}/${code}/getTicketByCode`);
  }
  fetchTicketsFromTicketCode({ code, numOfRowsPerPage, pageNumber }) {
    return this.http.get(`${this.api}/paginateFromTicketCode/${this.org.id}/${code}/${numOfRowsPerPage}/${pageNumber}`)
      .pipe(map((res: any) => res.payload));
  }
  fetchTicket(data: {
    id: any;
    type: any;
    date?: { endDate: any; startDate: any };
  }) {
    const payload = {
      ...this.newDate.getDateFilter(data.date),
      id: data && data.id ? data.id : this.user.groupID,
      orgID: this.org.id,
      type: data.type,
    };
    return this.http.post(this.api + "/getTickets", payload);
  }

  filterPaginatedTicket(payload) {
    const body = {
      ...payload,
      orgID: this.org.id
    }
    return this.http.post<any>(this.api + '/getTicketsWithOrWithoutFilter', body)
  }
  downloadTicketsCSV(payload) {
    const body = {
      ...payload,
      orgID: this.org.id
    }
    return this.http.post<any>(this.api + '/downloadTicketsCSV', body, { responseType: 'blob' as 'json' })
  }

  fetchPaginatedTicket(
    data: { id: any; type: any; date?: { endDate: any; startDate: any } },
    pagination: { numOfRowsPerPage: number; pageNumber: number }
  ) {
    const payload = {
      ...this.newDate.getDateFilter(data.date),
      ...pagination,
      id: data && data.id ? data.id : this.user.groupID,
      orgID: this.org.id,
      type: data.type,
    };
    return this.http.post<any>(this.api + "/getPaginatedTickets", payload);
  }

  fetchOwnerPaginatedTicket(payload: any) {
    return this.http.post<any>(this.api + "/getPaginatedTickets", payload);
  }

  fetchAg(id, pageNo, pageSize) {
    return this.http.get(this.api + `/getFilteredTickets/${id}/${pageNo}/${pageSize}`);
  }

  fetchAnywhere365Calls(orgId, limit, pageNumber){
    return this.http.get(this.api + `/anywhere365/paginatedCalls/${orgId}/${pageNumber}/${limit}`);
  }

  fetchFilteredTickets(by, payload: { date: any; mode: any }) {
    const body = {
      ...payload,
      ...this.newDate.getDateFilter(payload.date),
      id: "",
      mode: by !== "Type" ? Number(payload.mode) : 1,
      orgID: this.org.id,
      type: 3,
      year: 0,
      value: by !== "Type" ? "" : payload.mode,
    };
    return this.http.post(this.api + `/getFilteredTicketsBy${by}`, body);
  }

  fetchCustomeFilteredTickets(id, pageNo, pageSize) {
    return this.http.get(this.api + `/getFilteredTickets/${id}/${pageNo}/${pageSize}`);
  }

  editTicket(payload: TicketModel) {
    const currUser = this.gs.user;
    const actionBy = currUser.firstName + ' ' + currUser.lastName;
    let body = {
      ...payload,
      actionBy,
      prty: payload.priority,
      source: payload.source,
      status: payload.stat,
      agentID: payload.agentID, //? payload.agentID : this.user.id,
      agentName: payload.agentName,
      //? payload.agentName
      //: this.user.lastName + " " + this.user.firstName,
      groupID: payload.groupID,// ? payload.groupID : this.user.groupID,
      groupName: payload.groupName, //? payload.groupName : this.user.groupName,
    };
    return this.http.post(this.api + "/editTicket", body);
  }

  editTicketS(payload) {
    return this.http.post(this.api + "/editTicket", payload);
  }

  quickEditTicket(payload: TicketModel, message: string) {
    const currUser = this.gs.user;
    const actionBy = currUser.firstName + ' ' + currUser.lastName;
    let body = {
      ...payload,
      actionBy,
      prty: payload.priority,
      source: payload.source,
      status: payload.stat,
      agentID: payload.agentID, //? payload.agentID : this.user.id,
      agentName: payload.agentName,
      //? payload.agentName
      //: this.user.lastName + " " + this.user.firstName,
      groupID: payload.groupID,// ? payload.groupID : this.user.groupID,
      groupName: payload.groupName, //? payload.groupName : this.user.groupName,
    };
    return this.http.put(this.api + "/quickUpdateTicket?message=" + message + "&actionBy=" + actionBy, body);
  }
  
  fetchCustomFilters() {
    return this.http.get(
      this.api + `/${this.org.id}/${this.user.id}/getTicketCustomFilters`
    );
  }

  checkIfSupervisor(agentID) {
    return this.http.get<boolean>(`${this.api}/checkIfSupervisor/${this.org.id}/${agentID}`);
  }

  getTicketsByClientId(payload) {
    let body = {
      orgID: this.org.id.toString(),
      ...payload,
    };
    return this.http.post(this.api + `/getTicketsByClient`, body);
  }

  createCustomFilter(payload) {
    const body = {
      agentID: "",
      creatorID: this.user.id,
      groupID: "",
      name: payload.name,
      orgID: this.org.id,
      priority: payload.priority || "",
      ticketOwner: payload.ticketOwner || "",
      source: payload.source || "",
      status: payload.status || "",
      type: payload.type || "",
      startDate: payload.startDate
        ? this.newDate.getTimeStp(payload.startDate)
        : 0,
      endDate: payload.endDate ? this.newDate.getTimeStp(payload.endDate) : 0,
    };
    return this.http.post(this.api + "/newTicketCustomFilter", body);
  }
  deleteCustomFilter(id) {
    return this.http.post(this.api + `/${id}/deleteTicketCustomFilter`, {});
  }
  editCustomFilter(payload) {
    const body = {
      ...payload,
      startDate: payload.startDate
        ? this.newDate.getTimeStp(payload.startDate)
        : 0,
      endDate: payload.endDate ? this.newDate.getTimeStp(payload.endDate) : 0,
    };
    return this.http.post(this.api + `/editTicketCustomFilter`, body);
  }
  /**
   *
   * @param data {id: agentID or groupID or orgID, type: 1 = agent, 2 = group, 3 = org}
   * @returns Observable of getTicketsStatistics api endpoint.
   */
  fetchStatTicket(data: { id: any; type: number; startDate?: number, endDate?: number }) {
    const payload = {
      orgID: this.org.id,
      id: data && data.type == 2 && data.id == 0 ? this.user.groupID : data.id,
      type: data && data.type ? data.type : 2,
      startDate: data.startDate,
      endDate: data.endDate
    };
    console.log('data-type', data.type)
    return this.http.post(this.api + "/getTicketsStatistics", payload);
  }

  fetchAgentTicketStatistics(data: { id: any; type: number; startDate?: number, endDate?: number }) {
    return this.http.get(this.api + `/getAgentTicketStatistics/${this.org.id}/${data.id}/${data.startDate}/${data.endDate}`);
  }

  fetchGraphStat(dateFilter?: { endDate: any; startDate: any }, year?: number) {
    const body = {
      // ...this.newDate.getDateFilter(dateFilter),
      orgID: this.org.id,
      type: 3,
      id: this.user.groupID || "",
      year,
      endDate: 1,
      startDate: 1,
    };
    return this.http.post(this.api + "/getGraphStats", body);
  }

  fetchNewGraphStat(dateFilter?: { endDate: any; startDate: any },day?:number, month?:string,  year?: number) {
    const body = {
      // ...this.newDate.getDateFilter(dateFilter),
      orgID: this.org.id,
      type: 3,
      id: this.user.groupID || "",
      day,
      month,
      year,
      endDate: 1,
      startDate: 1,
    };
    return this.http.post(this.api + "/getGraphStats", body);
  }
  fetchStatTicketType(data: { type: number; id: any; statType: any }, filterDate: {startDate: number; endDate: number;}) {
    const payload = {
      ...data,
      orgID: this.org.id,
      statType: data.statType,
      id: data && data.type == 2 && data.id == 0 ? this.user.groupID : data.id,
      type: data && data.type ? data.type : 2,
    };
    const requireData = {
      ...payload, ...filterDate
    }
    return this.http.post(this.api + "/getTicketsOnStats", requireData);
  }

  fetchOwnerStatTicketType(data: { type: number; agentID: any; statType: any, filterType: any}) {
    const payload = {
      ...data,
      orgID: this.org.id,
      statType: data.statType,
      agentID: data && data.type == 2 && data.agentID == 0 ? this.user.id : data.agentID,
      type: data && data.type ? data.type : 2,
      filterType: data.filterType,
    };
    const requireData = {
      ...payload,
    }
    return this.http.post(this.api + "/getTicketsWithDoubleFilter", requireData);
  }

  getUnresolvedTicket(orgID) {
    return this.http.get(this.api + `/getDashboardUnresolved/${orgID}`);
  }
  assignTicket(payload) {
    
    const agentName = `${this.user.lastName} ${this.user.firstName}`;
    const currUser = this.gs.user;
    const actionBy = currUser.firstName + ' ' + currUser.lastName;
    const body = {
      actionBy: actionBy,
      ticketCode: payload.ticketCode,
      agentID: payload.agentID ? payload.agentID : this.user.id,
      agentName: payload.agentName ? payload.agentName : agentName,
      groupID: payload.groupID ? payload.groupID : this.user.groupID,
      groupName: payload.groupName ? payload.groupName : this.user.groupName,
      orgName: this.org.name,
      fromAgentID: payload.agentAssignedToTicketId,
      fromAgentName: payload.agentAssignedToTicketName
    };
    return this.http.post(this.api + "/assignTicket", body);
  }

  fetchAgent(type) {
    return this.http
      .get(this.api + `/getUserFullDetails/${this.org.id}/${type}`)
      .pipe(catchError(this.handleError));
  }
  fetcMappedAgent(type) {
    return this.http
      .get(this.signupApi + `/getOrganizationPersons/${this.org.id}/${type}`)
      .pipe(
        mergeMap((data: any[]) => {
          const result = data.map((dat) => ({
            ...dat.user,
            name: `${dat.user.firstName} ${dat.user.lastName}`,
          }));
          return of(result);
        })
      );
  }
  fetchTicketAgent() {
    // console.log(
    //   "all lenle",
    //   this.signupApi + `/getOrganizationPersons/${this.org.id}/6`
    // );
    return this.http
      .get(this.signupApi + `/getOrganizationPersons/${this.org.id}/7`)
      .pipe(
        mergeMap((data: any[]) => {
          // alert(JSON.stringify(data));

          const result = data.map((dat) => ({
            ...dat.user,
            name: `${dat.user.firstName} ${dat.user.lastName}`,
            organization: this.org,
          }));
          return of(result);
        })
      );
  }

  createTodo(payload) {
    const body = {
      ...payload,
      agentID: this.user.id,
      groupID: this.user.groupID,
      orgID: this.org.id,
      creatorID: this.user.id,
      creatorName: `${this.user.firstName} ${this.user.lastName}`,
      status: "UNDONE",
    };
    return this.http.post(this.api + "/newTodo", body);
  }
  getTodo(data) {
    const body = {
      orgID: this.org.id,
      id: data && data.type == 2 && data.id == 0 ? this.user.groupID : data.id,
      type: data && data.type ? data.type : 2,
    };
    return this.http.post(this.api + "/getUndoneTodos", body);
  }
  fetchTicketTodos(code) {
    return this.http.get(this.api + `/${code}/getTicketTodos`);
  }
  fetchTopCasesForTheCurrentMonth(orgID) {
    return this.http.get(this.api + `/getTopCasesForTheCurrentMonth/${orgID}`);
  }
  saveTodoAsDone(id) {
    return this.http.post(this.api + `/${id}/saveAsDone`, {});
  }
  createChatExtra(payload) {
    const body = {
      title: "Title",
      ...payload,
      creatorID: this.user.id,
      creatorName: `${this.user.firstName} ${this.user.lastName}`,
      internalResponseUser: false,
    };
    return this.http.post(this.api + "/newChatExtra", body);
  }
  fetchTicketChatExtra({ code, type }) {
    return this.http.get(this.api + `/${code}/${type}/getTicketChatExtras`);
  }

  getTicketReportByCode(code) {
    return this.http.get(this.api + `/${this.org.id}/${code}/getTicketReportByTicketCode`)
  }

  openOrCloseTicket({ code, type }) {
    const body = {
      closedByID: this.user.id,
      closedBy: `${this.user.firstName} ${this.user.lastName}`,
    };
    const { closedByID, closedBy } = body;
    return this.http.post(
      this.api + `/${code}/${type}/${closedByID}/${closedBy}/openOrCloseTicket`,
      {}
    );
  }
  fetchCustomerSatifyDashStats({ type, id }) {
    return this.http.get(
      this.api +
      `/${type}/${id}/${this.org.id}/getCustSatisfactionDashboardStats`
    );
  }
  fetchCustomerSatReport(dateFilter) {
    const body = {
      ...this.newDate.getDateFilter(dateFilter),
      orgID: this.org.id,
    };
    return this.http.post(this.api + "/getCustomerSatisfactionReports", body);
  }
  fetchGeneralStats(dateFilter?) {
    const body = {
      ...this.newDate.getDateFilter(dateFilter),
      orgID: this.org.id,
      type: 3,
      id: "",
    };
    return this.http.post(this.api + "/getGeneralStats", body);
  }
  removeTicketCode(sender) {
    const body = { org: this.org.id + "", sender };
    return this.http.post(this.chatUrl + "/ticket/remove-code", body);
  }
  sendMailgunMail({ to, agentName, subject, text, ticketCode, frontendChat = false }) {
    const agent = agentName ? agentName.split(" ")[0] : this.user.firstName;
    const htmlMsg = `<section><main>
                        <p>${text.replace(/\r\n|\r|\n/g, "<br />")}</p>
                        <br>
                        <b>${this.user.firstName || "Agent"}</b> from ${this.org.name
      }
                        <hr>
                        ${this.powerBy}
                    </main></section>`;
    const body = {
      from: `${this.user.firstName} from ${this.org.name} <${this.gs.orgEmailTicket}>`,
      to,
      subject: subject || "ENQUIRY",
      text: htmlMsg,
      ticketCode,
      frontendChat
    };
    return this.http.post(this.chatUrl + "/bots/email/mailgun/send", body);
  }

  fetchCustomerRating(rating) {
    return this.http.get(
      this.api + `/${this.org.id}/${rating}/getReportsByCustomerRating`
    );
  }
  fetchTicketTypes() {
    return this.http.get(`${this.api}/${this.org.id}/getTicketTypes`);
  }
  newOrEditTicketType(type: "newTicketType" | "editTicketType", payload) {
    const body = { deleted: true, ...payload, orgID: this.org.id };
    return this.http.post(`${this.api}/${type}`, body);
  }
  createDefaultTicketType(body) {
    return this.http.post(`${this.api}/createDefaultTicketType`, body);
  }
  deleteTicketType(id) {
    return this.http.delete(`${this.api}/${id}/deleteTicketType`);
  }
  getTicketCount(ids: any[]) {
    const payload = { orgID: this.org.id, agentIds: ids };
    return this.http.post(`${this.api}/getTicketCount`, payload);
  }
  fetchRelatedTickets(
    value: string,
    pagination: { numOfRowsPerPage: number; pageNumber: number },
    data?: { id?: any; type?: any; date?: { endDate: any; startDate: any } },
  ) {
    const payload = {
      value,
      ...pagination,
      ...this.newDate.getDateFilter(data.date),
      id: data && data.id ? data.id : this.user.groupID,
      orgID: this.org.id,
      type: data.type,
    };
    return this.http.post<any>(this.api + "/getRelatedTickets", payload);
  }
  mergeTickets(payload: { ticketCodes: any[], ticketIDs: any[] }) {
    const body = {
      ...payload,
      "orgID": this.org.id,
    }
    return this.http.post<any>(this.api + "/mergeTickets", body);
  }
  fetchMergedTickets(mergeID) {
    return this.http.get<any>(`${this.api}/getMergedTickets/${this.org.id}/${mergeID}`)
  }
  bulkAction(payload: bulkActionModel) {
    const userName = `${this.user.lastName} ${this.user.firstName}`
    const currUser = this.gs.user;
    const actionBy = currUser.firstName + ' ' + currUser.lastName;
    const body = {
      ...payload,
      actionBy: actionBy,
      agentID: payload.agentID ? payload.agentID : this.user.id,
      agentName: payload.agentName ? payload.agentName : userName,
      groupID: payload.groupID ? payload.groupID : this.user.groupID,
      groupName: payload.groupName ? payload.groupName : this.user.groupName,
      orgName: this.org.name,
      orgID: this.org.id,
      fromAgentID: this.user.id,
      fromAgentName: this.user.firstName + " " + this.user.lastName,
    };
    return this.http.post<any>(this.api + "/bulkAction", body);
  }

  getAutoAssignSettingByOrgID() {
    return this.http.get<any>(`${this.api}/getAutoAssignSettingByOrgID/${this.org.id}`)
  }


  getAutoAssignSettingByOrgIDForTenant() {
    return this.http.get<any>(`${this.api}/getAutoAssignSettingByOrgID/${this.tenantInfo.id}`)
  }

  toggleSettings(isOn) {
    return this.http.get<any>(`${this.api}/toggleSettings/${this.org.id}/${isOn}`)
  }


  createTicketAutoAssign(body) {
    return this.http.post<any>(`${this.api}/createAutoAssignSetting`, body)
  }

  getAutoAssignOptions() {
    return this.http.get<any>(`${this.api}/getAutoAssignOptions`)
  }

  deleteTicketAutoAssignment(id) {
    return this.http.delete<any>(`${this.api}/deleteAutoAssignSettingByID//${id}`)
  }

  assignAgents(body) {
    return this.http.post<any>(`${this.api}/assignAgents`, body)
  }

  getAssignedAgents() {
    return this.http.get<any>(`${this.api}/getAssignAgents/${this.org.id}`)
  }

  editAssignAgents(body) {
    return this.http.put<any>(`${this.api}/editAssignAgents`, body)
  }

  deleteAssignedAgents(id) {
    return this.http.delete<any>(`${this.api}/deleteAssignAgents/${id}`)
  }

  getTicketSource() {
    return this.http.get(`${this.api}/getTicketSourceByOrgID/${this.org.id}`)
  }

  createTicketSource(body) {
    const payload = { ...body, orgID: this.org.id }
    return this.http.post(`${this.api}/addTicketSource`, payload)
  }


  editTicketSource(body) {
    const payload = { ...body, orgID: this.org.id }
    return this.http.put(`${this.api}/editTicketSource`, payload)
  }

  deleteTicketSource(id) {
    return this.http.delete(`${this.api}/deleteTicketSource/${id}`)
  }
  getAllTicketStatus() {
    return this.http.get(`${this.api}/getAllTicketStatus`)
  }

  getTicketSourceStatisticsWithinPeriod(startTime, endTime) {
    return this.http.get(`${this.api}/getTicketSourceStatisticsWithinPeriod/${this.org.id}/${startTime}/${endTime}`)
  }

  /**
   * Error Handler
   */
  private handleError = (error: any): Observable<any> => {
    let message = "";
    if (error) {
      if (error.error) {
        message = error.error.message;
      } else {
        message = error.message;
      }
    }
    return of(null);
  };

  searchTickets(data: { term: any; }) {
    const payload = {
      orgID: this.org.id,
      term: data.term, 
    };
    console.log('payload', payload);
    // this.api = 'http://127.0.0.1:8080/ticketservice'
    return this.http.post(this.api + "/searchTickets", payload);
  }

  getTicketAuditByCode(code) {
    return this.http.get(`${this.api}/getTicket/audit/${code}`)
  }

  fetchStatTicketByDate(data: { id: any; type: number; startDate: number; endDate: number; }) {
    const payload = {
      orgID: this.org.id,
      id: data && data.type == 2 && data.id == 0 ? this.user.groupID : data.id,
      type: data && data.type ? data.type : 2,
      startDate: data.startDate,
      endDate: data.endDate
    };
    return this.http.post(this.api + "/getTicketsStatistics", payload);
  }

  getAllSupervisorIds() {
    return this.http.get<any>(`${this.api}/${this.org.id}/allSupervisorIds`)
  }

  filterPaginatedEscalatedTickets(payload) {
    const body = {
      ...payload,
      orgID: this.org.id
    }
    const { orgID, escalation, page, size } = body;
    return this.http.get<any>(this.api + `/paginatedEscalatedTickets/${orgID}/${escalation}/${page}/${size}`)
  }

  bulkOpenOrCloseTickets(payload) {
    return this.http.post(this.api + "/bulkOpenOrCloseTickets", payload);
  }

  bulkAssignTickets(payload) {
    return this.http.post(this.api + "/bulkAssignTickets", payload);
  }

  editBulkTickets(payload: TicketModel[]) {
    return this.http.post(this.api + "/bulkEditTickets/"+this.org.name, payload);
  }

  filterPaginatedInternalResponseTickets(payload) {
    const body = {
      ...payload,
      orgID: this.org.id
    }
    const { orgID, value, page, size } = body;
    return this.http.get<any>(this.api + `/paginatedInternalResponseTickets/${orgID}/${value}/${page}/${size}`)
  }


filterChart(body) {
  return this.http.post(this.api + "/getDashboardChartFilter", body);
}

  fetchTicketAgentForInternalResponse(orgId) {
    return this.http
      .get(this.signupApi + `/getOrganizationPersons/${orgId}/7`)
      .pipe(
        mergeMap((data: any[]) => {
          // alert(JSON.stringify(data));

          const result = data.map((dat) => ({
            ...dat.user,
            name: `${dat.user.firstName} ${dat.user.lastName}`,
            organization: this.org,
          }));
          return of(result);
        })
      );
  }

  createChatExtraForInternalResponse(payload) {
    const body = {
      title: "Title",
      ...payload,
      internalResponseUser: true,
      // creatorID: this.user.id,
      // creatorName: `${this.user.firstName} ${this.user.lastName}`,
    };
    return this.http.post(this.api + "/newChatExtra", body);
  }

  getAgentsTickets(payload) {
    return this.http.post(this.api + "/getAgentsTickets", payload);
  }

  createDepartment(payload) {
      return this.http.post(this.api + "/departments", payload);
  }

  fetchDepartmentById(id) {
    return this.http.get<any>(this.api + `/departments/${id}`)
  }

  fetchAllDepartmentsByOrg(orgId, pageNo = 0, pageSize = 10) {
    const query = `pageNo=${pageNo}&pageSize=${pageSize}`
    return this.http.get<any>(this.api + `/departments/${orgId}/all?${query}`)
  }

  updateDepartment(payload) {
    return this.http.patch(`${this.api}/departments/${payload.id}`, payload)
  }

  activateDepartment(id) {
    return this.http.get(`${this.api}/departments/${id}/activate`)
  }

  deactivateDepartment(id) {
    return this.http.get(`${this.api}/departments/${id}/deactivate`)
  }

  fetchGroupsTickets() {
    return this.http.get<any>(this.api + `/getGroupsTickets/${this.org.id}`);
  }

createTicketCategory(body) {
    return this.http.post(`${this.api}/categories`, body);
  }

  getTicketCategories(page, size) {
    return this.http.get<any>(this.api + `/categories/${this.org.id}/all?pageNo=${page}&pageSize=${size}`);
  }

  getTicketCategory(id) {
    return this.http.get<any>(this.api + `/categories/${id}`);
  }

  setTicketCategorySLA(id, slaTime) {
    return this.http.get<any>(this.api + `/categories/${id}/${slaTime}`);
  }

  deleteTicketCategory(id) {
    return this.http.delete<any>(this.api + `/categories/${id}`);
  }

  editTicketCategory(body, id) {
    return this.http.patch(`${this.api}/categories/${id}`, body);
  }

  createTicketSubCategory(body) {
    return this.http.post(`${this.api}/sub-categories`, body);
  }

  editTicketSubCategory(body, id) {
    return this.http.patch(`${this.api}/sub-categories/${id}`, body);
  }

  getTicketSubCategories(categoryID) {
    return this.http.get<any>(this.api + `/sub-categories/${this.org.id}/${categoryID}?pageNo=0&pageSize=100`);
  }

  deleteTicketSubCategory(id) {
    return this.http.delete<any>(this.api + `/sub-categories/${id}`);
  }

  createPolicyType(body) {
    return this.http.post(`${this.api}/policy-types`, body);
  }

  getPolicyTypes(page, size) {
    return this.http.get<any>(this.api + `/policy-types/${this.org.id}/all?pageNo=${page}&pageSize=${size}`);
  }

  getPolicyType(id) {
    return this.http.get<any>(this.api + `/policy-types/${id}`);
  }

  deletePolicyType(id) {
    return this.http.delete<any>(this.api + `/policy-types/${id}`);
  }

  editPolicyType(body, id) {
    return this.http.patch(`${this.api}/policy-types/${id}`, body);
  }

  createBusinessType(body) {
    return this.http.post(`${this.api}/business-types`, body);
  }

  getBusinessTypes(page, size) {
    return this.http.get<any>(this.api + `/business-types/${this.org.id}/all?pageNo=${page}&pageSize=${size}`);
  }

  getBusinessType(id) {
    return this.http.get<any>(this.api + `/business-types/${id}`);
  }

  deleteBusinessType(id) {
    return this.http.delete<any>(this.api + `/business-types/${id}`);
  }

  editBusinessType(body, id) {
    return this.http.patch(`${this.api}/business-types/${id}`, body);
  }

  mergeTicket(body) {
    return this.http.post(`${this.api}/merge-tickets`, body);
  }
}
